module.exports = __webpack_public_path__ + "img/my-school-icon.e13248f0.png";